import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { INSTAGRAM_POSTS, CONTACT } from "@/data/content";

export const InstagramFeed = () => {
  const { t } = useLang();
  return (
    <section data-testid="instagram-section" className="py-24 md:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <Reveal><Overline className="mb-4">{t.instagram.overline}</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-[#1A1A1A]">
                {t.instagram.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <a
              data-testid="instagram-follow-btn"
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-[#1A1A1A] border-b border-[#C5A880] pb-1 hover:text-[#B0926A] transition-colors"
            >
              <Instagram size={16} /> {t.instagram.cta}
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {INSTAGRAM_POSTS.map((post, i) => (
            <Reveal key={post.url} delay={i * 0.08}>
              <a
                data-testid={`instagram-post-${i}`}
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square overflow-hidden bg-[#EBE5D9]"
              >
                <img
                  src={post.img}
                  alt="Olivier Boës magic performance on Instagram"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/40 transition-colors duration-500 flex items-center justify-center">
                  <ArrowUpRight className="text-[#FAF9F6] opacity-0 group-hover:opacity-100 transition-opacity duration-500" size={28} />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
